import { NavItem } from "../atoms/navItem";
import { useEffect, useState, useContext, useRef } from "react";
import { PageContext, ThemeContext, UserContext } from "../App";
import { ip } from "../api/api";
import defaultLogo from "../assets/expligo_logo.png"
import publicDefaultLogo from "../assets/expligo_abstract_5.png"
import { handleDocumentValues } from "../functions/handleTheme";
import { VerticalLayout } from "./layout";
import { IconAtom } from "../atoms/iconAtom";
import { borderRadius, borderStyle, padding } from "polished";
import { TextAtom } from "../atoms/TextAtom";

export function SideBar({ navigationComps, active, onClick, isSidebarOpen, setIsSidebarOpen, handleLogoClick, brandingLogo, alignment, hide }) {
  const userContext = useContext(UserContext);
  const themeContext = useContext(ThemeContext);
  const navigationContext = useContext(PageContext);
  
  const [sidebar_items, setSidebarItems] = useState({
  "sales": {
    "icon": "target",
    "title": "Sales",
    "navData": [
      { "navID": 1, "navTitle": "Sales dashboard", "icon": "dashboard", "permission": "view_sales_dashboard" }, 
      { "navID": 2, "navTitle": "Learnings", "icon": "courses", "permission": "edit_sales_settings" },
      { "navID": 17, "navTitle": "Tasks", "icon": "tasks", "permission": "edit_sales_settings" },
      { "navID": 20, "navTitle": "Leads", "icon": "leads", "permission": "edit_sales_settings" },
      { "navID": 11, "navTitle": "Reports", "icon": "chart", "permission": "view_sales_dashboard" }
    ]
  },
  "onboarding": {
    "icon": "workforce",
    "title": "Onboarding",
    "navData": [
      { "navID": 101, "navTitle": "Onboarding learnings", "icon": "courses", "permission": "learnings_onboarding" },
      { "navID": 102, "navTitle": "Onboarding workflows", "icon": "calendar", "permission": "workflow_onboarding" },
      { "navID": 103, "navTitle": "Onboarding reports", "icon": "chart", "permission": "onboarding_reports" }

    ]
  },
  "support": {
    "icon": "support",
    "title": "Support",
    "navData": [
      { "navID": 201, "navTitle": "Support dashboard", "icon": "dashboard", "permission": "support_dashboard" },
      { "navID": 202, "navTitle": "Knowledge base", "icon": "courses", "permission": "edit_support_settings" },
      { "navID": 203, "navTitle": "Tickets", "icon": "tasks", "permission": "edit_support_settings" }
    ]
  },
  "retentie": {
    "icon": "business",
    "title": "Retentie",
    "navData": [
      { "navID": 301, "navTitle": "Retention learnings", "icon": "courses", "permission": "retention_learnings" },
      { "navID": 302, "navTitle": "Retention campaign", "icon": "calendar", "permission": "retention_campaign" },
      
      { "navID": 303, "navTitle": "Follow-ups", "icon": "time", "permission": "edit_retention_settings" },
      { "navID": 305, "navTitle": "Reports", "icon": "chart", "permission": "view_retention_dashboard" }
    ]
  },
  "workforce": {
    "icon": "users",
    "title": "Workforce",
    "navData": [
      { "navID": 401, "navTitle": "Workforce dashboard", "icon": "dashboard", "permission": "view_workforce_dashboard" },
      { "navID": 402, "navTitle": "Trainingen", "icon": "courses", "permission": "edit_workforce_settings" },
      { "navID": 403, "navTitle": "Werknemers", "icon": "users", "permission": "edit_workforce_settings" },
      { "navID": 404, "navTitle": "Communicatie", "icon": "message", "permission": "edit_workforce_settings" },
      { "navID": 405, "navTitle": "Reports", "icon": "chart", "permission": "view_workforce_dashboard" }
    ]
  }
});
  const [brandingLogoState, setBrandingLogo] = useState("");
  const [alignmentState, setAlignmentState] = useState('left');
  const sidebarRef = useRef(null);
  const isPublic = userContext.account_type === 1;
  const settingObj = {
    navID: 8,
    icon: "setting",
    navTitle: "Instellingen",
  };
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.SET_ALIGNMENT) {
        setAlignmentState(event.data.SET_ALIGNMENT);
      }
      if (event.data?.SET_LOGO) {
        const file = event.data.SET_LOGO;
        if (file instanceof File) {
          const logoUrl = URL.createObjectURL(file);
          setBrandingLogo(logoUrl);
        } else {
          setBrandingLogo(`${ip}/${event.data.SET_LOGO}`);
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => window.removeEventListener("message", handleMessage);
  }, []);



  useEffect(() => {
    function handleClickOrScrollOutside(event) {
      if (
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        setIsSidebarOpen(false);
      }
    }

    function handleScroll() {
      setIsSidebarOpen(false);
    }

    if (isSidebarOpen) {
      document.addEventListener("mousedown", handleClickOrScrollOutside);
      window.addEventListener("scroll", handleScroll);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOrScrollOutside);
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isSidebarOpen]);


  useEffect(() => {
    if (sidebarRef.current && themeContext?.sidebar_style !== undefined) {
      handleDocumentValues(window.document, 'sidebar_style', themeContext.sidebar_style);
    }
  }, [themeContext?.sidebar_style]);


  
  const headerSidebarStyle = {
    display: "flex",
    justifyContent: alignment === 'left' ? 'flex-start' : alignment === 'center' ? 'center' : 'flex-end',
  };
  if (hide) {
    return <></>;
  }
  return (
    <div
      ref={sidebarRef}
      style={{ paddingLeft: "0.7rem", paddingRight: "0.7rem" }}
      className={`vertical complete-width sidebar card-background-color ${isSidebarOpen ? "open" : "closed"} ${isPublic ? "public-sidebar" : ""} ${isMobile ? "mobile-sidebar" : ""}`}>
      <div className="header-sidebar" style={headerSidebarStyle}>
        <a href="/" onClick={handleLogoClick}> <img style={{ height: "3.1rem", objectFit: "contain" }} src={brandingLogoState ? brandingLogoState : brandingLogo ? `${ip}/api/media/${brandingLogo}` : isPublic ? publicDefaultLogo : defaultLogo} alt="logo" /></a>
      </div>
      <div className="top-sidebar grid-layout phone-grid-layout" >
        {Object.keys(sidebar_items).map((nav) => {
          const navData = sidebar_items[nav]
          return (
            <SubNavComp
              nav={navData}
            />
          )
        }
        )}
      </div>
      <IconAtom
        onClick={() => navigationContext.handleNavigation({...navigationContext.sidebar,  navigation: 8 })}
        color={navigationContext.sidebar.navigation === 8 ? "var(--primary-600)" : "white"}
        iconSize={25}
        style={{
          height: "3rem",
          minWidth: "3rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: navigationContext.sidebar.navigation === 8 ? "white" : "unset",
          borderRadius: "0.5rem", borderWidth: "0.5px",
          cursor:"pointer",
          color:"white",

          alignSelf: "center"
        }}
       
        icon2={"setting"} />
    </div>
  );


}



const SubNavComp = ({ active, onClick, nav }) => {
  
  const navigationContext = useContext(PageContext);
  const openMenu = nav.navData.filter(row => row.navID === navigationContext.sidebar.navigation).length > 0
  return (
    <VerticalLayout className={`phone-nav ${openMenu ? "active-phone-nav" : ""}`}>
      <IconAtom
        color={openMenu ? "var(--primary-600)" : "white"}
        iconSize={25}
        style={{
          height: "3rem",
          minWidth: "3rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: openMenu ? "white" : "unset",
          borderRadius: "0.5rem", borderWidth: "0.5px",
          cursor:"pointer",
          paddingTop: "0rem"
        }}
        onClick={() => navigationContext.handleNavigation({...navigationContext.sidebar,  navigation: nav.navData[0].navID })}
        icon2={nav.icon} />
       {!openMenu && <TextAtom style={{fontSize:"0.5rem", marginTop:"-0.8rem", color:"white", fontWeight:"bold", textAlign: "center"}} title={nav.title} />}
      {
        openMenu &&
        <VerticalLayout  className="phone-nav-sub-bar" style={{ gap: "0.2rem",backgroundColor: "var(--primary-600)", borderRadius: "0.65rem", height: "max-content" ,marginRight: 0}}>
        {nav.navData.map((comp, index) => {
          {/* if (userContext.permissions.includes(comp.permission)) { */ }
          return (
            <NavItem
              style={{ display: "flex", alignItems: "center",width:"unset", justifyContent: "center", backgroundColor:comp.navID ==  navigationContext.sidebar.navigation && "white",color:comp.navID == navigationContext.sidebar.navigation && "var(--primary-600)", margin:"0.4rem", borderRadius: "0.5rem"   }}
              key={comp.navID}
              onClick={() => navigationContext.handleNavigation({...navigationContext.sidebar,  navigation: comp.navID })}
              active={active === comp.navID}
              showIndicator={false}
              // navtitle={comp.navTitle}
              icon2={comp.icon}
              navdata={`navItem${comp.navID}`}
            />
          );

        })}
      </VerticalLayout>}
    </VerticalLayout>

  )
}



